
import clsBaseGlobal from './base'

const arrFillable = [
    "csm_manday_show_country",
    "csm_manday_show_bsn",
    "csm_manday_show_department",
];


class clsGlobalMandays extends clsBaseGlobal {

    // From company settings edit
    csm_manday_show_country     = false;
    csm_manday_show_bsn         = false;
    csm_manday_show_department  = false;

    get fillable() { return arrFillable; }

    fill(data) {
        data = data ||{};
        data.csm_manday_show_country    = !!data.csm_manday_show_country;
        data.csm_manday_show_bsn        = !!data.csm_manday_show_bsn;
        data.csm_manday_show_department = !!data.csm_manday_show_department;

        return super.fill(data);
    }
}

export default clsGlobalMandays;